import { makeStyles } from '@material-ui/core/styles';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { color } from '../../app/theme';
import { setProgress, updateDatasset } from '../../features/aiBotSlice';

const useStyles = makeStyles(
  () => ({
    root: {
      position: 'fixed',
      width: 'calc(100vw - 240px)',
      top: '80px',
      left: '240px',
      background: '#fafafa',
      padding: '24px 44px',
      fontSize: '15px',
      fontStyle: 'normal',
      fontWeight: '500',
      lineHeight: 1,
      color: color.$13,
      borderBottom: `1px solid ${color.$9}`,
      zIndex: '1299',
    },
    subtitle: {
      marginTop: 6,
      fontSize: '13px',
      fontWeight: '400',
      lineHeight: '13px',
      color: color.$11,
      marginBottom: 12,
    },
    progressBlock: {
      fontSize: '13px',
      fontWeight: '500',
      lineHeight: '13px',
      color: color.$11,
      display: 'flex',
      alignItems: 'center',
    },
    progress: {
      width: '100%',
      height: '5px',
      background: color.$8,
      borderRadius: 2.5,
    },
    progressBar: {
      height: '5px',
      background: color.$1,
      borderRadius: 2.5,
    },
    progressText: {
      marginRight: 10,
    },
  }),
  { name: 'ProgressContainer' },
);

function ProgressContainer({ pathKey }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { datasets, progress, client, clientReady } = useSelector(
    store => store.aiBot,
  );

  const datasetsRef = useRef(null);
  datasetsRef.current = datasets;

  const progressPercentage = parseInt(
    ((progress?.complete || 0) / (progress?.total || 0)) * 100,
    10,
  );

  let temp = [];

  const handleEvent = event => {
    const { type, data } = event || {};
    switch (type) {
      case 'aibot_refresh_progress':
        dispatch(
          setProgress({
            done: data?.done,
            complete: data?.complete,
            total: data?.total,
          }),
        );

        temp = temp.filter(te => te?.id !== data?.dataset?.id);
        temp.push(data?.dataset);
        dispatch(updateDatasset(temp));

        break;
      default:
        break;
    }
  };

  useEffect(() => {
    if (clientReady) {
      client.on('event', handleEvent);
    } else {
      client?.off('event', handleEvent);
    }
  }, [clientReady]);

  if (progress?.done) {
    return null;
  }

  return (
    <div className={classes.root}>
      <div>{t(`${pathKey}:progress.title`)}</div>
      <div className={classes.subtitle}>
        {t(`${pathKey}:progress.subtitle`)}
      </div>
      <div className={classes.progressBlock}>
        <div className={classes.progressText}>
          {t(`${pathKey}:progress.percentage`, {
            value: progressPercentage || 0,
          })}
        </div>
        <div className={classes.progress}>
          <div
            className={classes.progressBar}
            style={{ width: `${progressPercentage}%` }}
          />
        </div>
      </div>
    </div>
  );
}

export default ProgressContainer;
